var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageOutline28 = function SvgMessageOutline28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillRule: "evenodd",
    d: "M2.63 9.696c0-3.639 3.4-6.428 7.382-6.428 3.98 0 7.38 2.79 7.38 6.428s-3.4 6.428-7.38 6.428a8.4 8.4 0 0 1-2.519-.384c-.929.867-2.278 1.284-3.93 1.349a.925.925 0 0 1-.875-1.3c.399-.894.915-1.92.976-2.814a5.77 5.77 0 0 1-1.033-3.279m7.382-5.142c-3.462 0-6.096 2.39-6.096 5.142 0 .988.331 1.915.915 2.7.082.111.126.246.126.384 0 1.05-.418 2.04-.845 2.981 1.322-.14 2.19-.563 2.712-1.179a.64.64 0 0 1 .716-.185 7 7 0 0 0 2.472.441c3.462 0 6.095-2.39 6.095-5.142 0-2.751-2.633-5.142-6.095-5.142",
    clipRule: "evenodd"
  })));
};
export default SvgMessageOutline28;